"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicThumbnailRedirectUrl = getPublicThumbnailRedirectUrl;
exports.getPrivateThumbnailRedirectUrl = getPrivateThumbnailRedirectUrl;
exports.getVideoOrImageThumbnailUrl = getVideoOrImageThumbnailUrl;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _fileAccessibility = require("./fileAccessibility");

var _getApiHostForEnviroment = _interopRequireDefault(require("./getApiHostForEnviroment"));

var ThumbnailSizes = _interopRequireWildcard(require("../enums/ThumbnailSizes"));

function getPublicThumbnailRedirectUrl(file, thumbSize) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isFallbackImageDisabled = options.isFallbackImageDisabled,
      shouldUpscale = options.shouldUpscale,
      fallbackSize = options.fallbackSize,
      noCache = options.noCache;

  var url = "//" + (0, _getApiHostForEnviroment.default)() + "/filemanager/api/v3/files/thumbnail-redirect/" + file.get('id') + "?size=" + thumbSize + "&portalId=" + _PortalIdParser.default.get();

  if (isFallbackImageDisabled) {
    url = url + "&errorOnPlaceholder=true";
  }

  if (shouldUpscale) {
    url = url + "&upscale=true";
  }

  if (fallbackSize) {
    url = url + "&fallbackSize=" + fallbackSize;
  }

  if (noCache) {
    return url + "&t=" + Date.now();
  }

  return url + "&t=" + file.get('updated');
}

function getPrivateThumbnailRedirectUrl(file, thumbSize) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isFallbackImageDisabled = options.isFallbackImageDisabled,
      shouldUpscale = options.shouldUpscale,
      fallbackSize = options.fallbackSize,
      noCache = options.noCache;

  var url = "//" + (0, _getApiHostForEnviroment.default)() + "/filemanager/api/v2/files/" + file.get('id') + "/signed-url-redirect?size=" + thumbSize + "&portalId=" + _PortalIdParser.default.get();

  if (isFallbackImageDisabled) {
    url = url + "&errorOnPlaceholder=true";
  }

  if (shouldUpscale) {
    url = url + "&upscale=true";
  }

  if (fallbackSize) {
    url = url + "&fallbackSize=" + fallbackSize;
  }

  if (noCache) {
    return url + "&t=" + Date.now();
  }

  return url + "&t=" + file.get('updated');
}

function getVideoOrImageThumbnailUrl(file) {
  var thumbSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ThumbnailSizes.THUMB;
  var options = arguments.length > 2 ? arguments[2] : undefined;

  if ((0, _fileAccessibility.getIsFilePrivate)(file)) {
    return getPrivateThumbnailRedirectUrl(file, thumbSize, options);
  }

  return getPublicThumbnailRedirectUrl(file, thumbSize, options);
}